import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ecvs',
  templateUrl: './ecvs.component.html',
  styleUrls: ['./ecvs.component.scss']
})
export class EcvsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
